import React, { useCallback, useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import M_WOS_BASIC_03 from './M_WOS_BASIC_03';
import { WorkingCheckActions } from '../../../Reducer/WorkingCheckReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useSearch1, useSearch2 } from './M_WOS_BASIC_03_Query';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import {
  normalizeWosBasicR2,
} from '../ui/workStopUtils';

export default function M_WOS_BASIC_03F() {
  const { id } = useParams();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const workingCheck = useSelector((state) => state.workingCheck);
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const [workStopData, setWorkStopData] = useState(null);
  const [stopImageList, setStopImageList] = useState([]);

  const workStopCd = id || workingCheck?.workStopCd;

  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/Home'),
  });

  const ToggleDrawer = (anchor, open) => (e) => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: open,
        type: open ? bottomSheetState?.type : bottomSheetState?.type,
      })
    );
  };

  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      if (!rows || rows.length === 0) {
        setWorkStopData(null);
        setStopImageList([]);
        return;
      }
      const normalized = normalizeWosBasicR2(rows);
      if (normalized?.type === 'Error') {
        setWorkStopData(null);
        setStopImageList([]);
        return;
      }
      setWorkStopData(normalized);
      const path = normalized?.stopImagePath ?? '';
      setStopImageList(
        path
          ? String(path)
              .split(',')
              .map((u) => u.trim())
              .filter(Boolean)
          : []
      );
      if (normalized.solveYn === 'Y') {
        navigate('/Home');
        dispatch(WorkingCheckActions.clearWorkStop());
      }
    },
  });

  const SearchLogic1 = useCallback(async () => {
    if (!workStopCd) return;
    await Search1Async({ workStopCd });
  }, [workStopCd, Search1Async]);

  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      if (!rows || rows.length === 0) return;
      const { workStopYn, workStopCd: newCd } = rows[0];

      if (workStopYn === 'Y') {
        dispatch(WorkingCheckActions.setStopWorking(1));
        dispatch(WorkingCheckActions.setWorkStopCd(newCd));

        if (id !== newCd) {
          navigate(`/M_WorkStop/${newCd}`, { replace: true });
        }
      } else {
        dispatch(WorkingCheckActions.clearWorkStop());
        navigate('/Home', { replace: true });
      }
    },
  });

  const SearchLogic2 = useCallback(async () => {
    await Search2Async({ userInfo });
  }, [Search2Async, userInfo]);

  useEffect(() => {
    Init();
  }, [workStopCd]);

  const Init = async () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 중지'));
    if (workStopCd) {
      SearchLogic1();
    } else {
      SearchLogic2();
    }
  };
  useEffect(() => {
    if (
      bottomSheetState.bottom &&
      bottomSheetState.type === 'checkWorkStop' &&
      !workStopData &&
      workStopCd
    ) {
      SearchLogic1();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomSheetState.bottom, bottomSheetState.type]);

  useEffect(() => {
    let listener = null;
    const setup = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          listener = await App.addListener('appStateChange', (state) => {
            if (state.isActive) SearchLogic2();
          });
        } catch (e) {
          console.error('❌ appStateChange listener 실패:', e);
        }
      }
    };
    setup();
    return () => {
      if (listener) listener.remove();
    };
  }, [SearchLogic2]);

  return (
    <div>
      <M_WOS_BASIC_03
        ToggleDrawer={ToggleDrawer}
        userInfo={userInfo}
        workStopData={workStopData}
        SearchLogic1={SearchLogic1}
        stopImageList={stopImageList}
        setStopImageList={setStopImageList}
      />
    </div>
  );
}
